import './common/fonts/icons/iconfont.css'
import './common/stylus/hippius.styl'

import HView from './components/HView'
import HHeader from './components/HHeader'
import HContent from './components/HContent'
import Scroll from './components/Scroll'
import Swipe from './components/Swipe'
import Picker from './components/Picker'
import Group from './components/Group'
import Check from './components/Check'

// created by zy.love
import HButton from './components/HButton'
import Spin from './components/Spin'
import Dialog, {
  AlertPlugin,
  ConfirmPlugin,
  PromptPlugin,
  Loading,
  LoadingPlugin,
  Toast,
  ToastPlugin,
  Notify,
  NotifyPlugin,
} from './components/Dialog'
import TopTip from './components/TopTip'

export {
  HView,
  HHeader,
  HContent,
  Scroll,
  Swipe,
  Picker,
  Group,
  Check,
  HButton,
  Spin,
  Dialog,
  AlertPlugin,
  ConfirmPlugin,
  PromptPlugin,
  Loading,
  LoadingPlugin,
  Toast,
  ToastPlugin,
  Notify,
  NotifyPlugin,
  TopTip,
}

const version = '0.0.1'

export default {
  version,
}



// WEBPACK FOOTER //
// ./src/components/hippius/index.js